import { createRouter } from "@tanstack/react-router"
import { routeTree } from "../routeTree.gen.ts"
import * as Query from "./query.ts"

export const router = createRouter({
  defaultPendingMinMs: 0,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  defaultPreloadGcTime: 0,
  context: {
    authData: undefined as never,
    queryClient: Query.client,
    zero: undefined as never,
  },
  routeTree,
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
